import { render, staticRenderFns } from "./index.vue?vue&type=template&id=312c88fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=312c88fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c88fc",
  null
  
)

export default component.exports